import React from 'react';
import { relationshipCompanySearch } from '@/utils/typesense/clients/relationshipCompanySearch';
import { RelationshipSelect } from '@/components/selects/RelationshipSelect';

const companyLabels = {
	inputId: 'relationship-company-select',
	placeholder: 'Search for company',
	loadingText: 'Loading companies...',
	emptyText: 'No companies found',
};

const mapCompanyOption = {
	fromHit: (hit) => ({
		id: hit.id,
		name: hit.name,
	}),
	label: (option) => option?.name ?? '',
	optionText: (option) => option.name,
	selectedLabel: (value) => (typeof value === 'object' ? (value?.name ?? '') : (value ?? '')),
};

export const RelationshipCompanySelect = ({
	value,
	onChange,
	disabled = false,
	error = false,
	helperText,
	required = false,
}) => (
	<RelationshipSelect
		searchClient={relationshipCompanySearch}
		indexName='relationshipCompanies'
		labels={companyLabels}
		mapOption={mapCompanyOption}
		value={value}
		disabled={disabled}
		error={error}
		helperText={helperText}
		required={required}
		onSelect={(option) =>
			onChange?.({
				relationshipCompanyId: option.id ?? null,
				relationshipCompanyName: option.name ?? '',
			})
		}
		onClear={() =>
			onChange?.({
				relationshipCompanyId: null,
				relationshipCompanyName: '',
			})
		}
	/>
);
